var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row align-items-center mb-1" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col-md-2 offset-md-4 text-right center" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-warning btn-fill",
              attrs: { type: "submit" },
              on: { click: _vm.editExpert }
            },
            [_vm._v("Edit Expert")]
          )
        ])
      ]),
      _vm._v(" "),
      _vm.expert
        ? _c("div", { staticClass: "table-responsive" }, [
            _c("table", { staticClass: "table table-bordered table-light" }, [
              _c("tr", [
                _c("th", [_vm._v("Id")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.expert.expertId))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Name")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.expert.name))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Biography")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.expert.biography))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Interest Name")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.expert.interestName))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Expertise")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.expert.experties))])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Areas of Expertise")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.expert.areasofexpertise))])
              ]),
              _c("tr", [
                _c("th", { staticClass: "align-content-center" }, [
                  _vm._v("Image")
                ]),
                _vm._v(" "),
                _c("td", [
                  _c("img", {
                    staticClass: "detail-thumbnail",
                    attrs: { src: _vm.expert.small_image, alt: "expert-image" }
                  })
                ])
              ]),
              _vm._v(" "),
              _c("tr", [
                _c("th", [_vm._v("Corp. Associations")]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.expert.csvCorpNames))])
              ])
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-md-6" }, [
      _c("div", { staticClass: "h2" }, [_vm._v("Expert Details")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f9fd6114", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f9fd6114","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard/Views/Experts/ExpertDetails.vue
// module id = xxVO
// module chunks = 0